module.exports = __webpack_public_path__ + "img/logo.f5d00a9d.png";